import { Grid } from "@mui/material";
import { useSelector } from "react-redux";

const Section = ({ creator, format, optimization_target, classes }) => {
  const isLoggedIn = useSelector((state) => state.isLoggedIn);
  return (
    <Grid item xs={12} sm={12} md={12}>
      <Grid container spacing={2}>
        <Grid
          item
          xs={12}
          sm={12}
          md={12}
          className={classes.storyInfosWrapper}
        >
          {creator?.name && isLoggedIn && (
            <div className={classes.storyInfos}>
              <span className={classes.storyInfosKey}>Created by:</span>
              <span className={classes.storyInfosValue}>{creator.name}</span>
            </div>
          )}
          {format?.name && (
            <div className={classes.storyInfos}>
              <span className={classes.storyInfosKey}>Format:</span>
              <span className={classes.storyInfosValue}>{format.name}</span>
            </div>
          )}
          {optimization_target?.name && (
            <div className={classes.storyInfos}>
              <span className={classes.storyInfosKey}>Goal:</span>
              <span className={classes.storyInfosValue}>
                {optimization_target.name}
              </span>
            </div>
          )}
        </Grid>
      </Grid>
    </Grid>
  );
};
export default Section;
